import request from '../utils/request'
import { getQuickToken } from '../utils/auth'

// 参数类型-大类
export function getCategory(code) {
  return request({
    url: '/share/constant/getListByPar?isVaild=1&constantCode=' + code,
    method: 'get'
  })
}


// 所属参数类型
export function getPropertyList(constantCode) {
  return request({
    url: '/share/property/getListByPar?isVaild=1&constantCode=' + constantCode,
    method: 'get',
    data: {}
  })
}

// 查询所有商家类型-大类
export function getConstantCategory(code) {
  return request({
    url: '/share/shopType/list?isVaild=1&constantCategory=' + code,
    method: 'get'
  })
}

// 查询商家-小类
export function getTypesList(constantCode) {
  return request({
    url: '/share/typeProperty/getListByPar?isVaild=1&constantCode=' + constantCode,
    method: 'get',
    data: {}
  })
}

// 查询省份接口  
export function getProvinceByName(name) {
  return request({
    url: '/share/province/getList?provinceName=' + name,
    method: 'get',
    data: {}
  })
}

// 查询市接口
export function getCityByName(name) {
  return request({
    url: '/share/city/getList?cityName=' + name,
    method: 'get',
    data: {}
  })
}

// 查询区接口
export function getAreaByName(name) {
  return request({
    url: '/share/area/getList?areaName=' + name,
    method: 'get',
    data: {}
  })
}

// 查询街道接口
export function getStreetByName(name) {
  return request({
    url: '/share/street/getListByPar?streetName=' + name,
    method: 'get',
    data: {}
  })
}


// 查询省份接口 
export function getProvince() {
  return request({
    url: '/share/province/getList',
    method: 'get',
    data: {}
  })
}

// 查询市接口
export function getCity(code) {
  return request({
    url: '/share/city/getList?provinceCode=' + code,
    method: 'get',
    data: {}
  })
}

// 查询区接口
export function getArea(code) {
  return request({
    url: '/share/area/getList?cityCode=' + code,
    method: 'get',
    data: {}
  })
}

// 查询街道接口
export function getStreet(code) {
  return request({
    url: '/share/street/getListByPar?areaCode=' + code,
    method: 'get',
    data: {}
  })
}

// 商户基本信息保存
export function mallBasic(data) {
  return request({
    url: '/mall/basic',
    method: 'post',
    data: data
  })
}

// 门店基本信息保存---暂时使用此接口保存
export function shopBasic(data) {
  return request({
    url: '/shop/check',
    method: 'post',
    data: data
  })
}

// 查询门店列表
export function getShopList() {
  return request({
    url: '/shop/check/shopList',
    method: 'get'
  })
}

// 查询选中的套餐
export function getMealInfo(setMealCode) {
  return request({
    url: '/share/meal/getInfoByPar?setMealCode=' + setMealCode,
    method: 'get',
    data: {}
  })
}

// 获取已设置的套餐和商家比例(是否已付款)
export function getAnnualFeeInfo(shopMallCode) {
  return request({
    url: '/share/annualFee/getInfoByPar?shopMallCode=' + shopMallCode,
    method: 'get',
    data: {}
  })
}

// 支付小程序注册费用
export function payApplet(query) {
  return request({
    url: '/shop/check/payApplet',
    method: 'get',
    params: query
  })
}

// 获取已设置的套餐列表
export function getPackageList(query) {
  return request({
    url: '/share/meal/selectListInfo',
    headers: {
      isToken: true,
      Authorization: getQuickToken()
    },
    method: 'get',
    params: query
  })
}

// 获取付款二维码
export function getFkdateShopAnnualFee(data) {
  return request({
    url: '/shop/check/fkdateShopAnnualFee',
    method: 'post',
    data: data
  })
}

// 获取商家基本信息（调商家比例、调市场人员比例）
export function getShopBasicInfo(shopCode) {
  return request({
    url: '/shop/basic/getInfoByPar?shopCode=' + shopCode,
    method: 'get',
    data: {}
  })
}

// 确定签约
export function examineConfirmed(shopCode) {
  return request({
    url: '/shop/examine/updateConfirmed?shopCode=' + shopCode,
    method: 'get',
    data: {}
  })
}

// 进件 市场人员 合同查看
export function contract(code) {
  return request({
    url: '/lms/marketCheck/contract?articleCategory='+code,
    method: 'get'
  })
}

////////////////

// 保存商家比例设置
export function saveAnnualFee(data) {
  return request({
    url: '/share/annualFee',
    headers: {
      isToken: true,
      Authorization: getQuickToken()
    },
    method: 'post',
    data: data
  })
}

// 升级套餐-保存商家比例设置
export function upgradeSetMeal(data) {
  return request({
    url: '/share/annualFee/upgradeSetMeal',
    headers: {
      isToken: true,
      Authorization: getQuickToken()
    },
    method: 'post',
    data: data
  })
}


// 查询所有市场人员信息
export function getMarketList(query) {
  return request({
    url: '/lms/salesRelation/selMarketList',
    headers: {
      isToken: true,
      Authorization: getQuickToken()
    },
    method: 'get',
    params: query
  })
}

// 新增、修改 商家对应市场人员
export function addMarket(data) {
  return request({
    url: '/lms/salesPeople/addOrUpdate',
    headers: {
      isToken: true,
      Authorization: getQuickToken()
    },
    method: 'post',
    data
  })
}

// 查询商家对应市场人员 比例
export function getMarketInfo(shopCode) {
  return request({
    url: '/lms/salesPeople/' + shopCode,
    headers: {
      isToken: true,
      Authorization: getQuickToken()
    },
    method: 'get',
  })
}

// 查询门店信息（获取小程序费用是否支付）
export function getBasicShop(shopCode) {
  return request({
    url: '/shop/basic/getShop/'+shopCode,
    method: 'get',
  })
}

// 获取园区设置
export function getSettingPark(query) {
  return request({
    url: '/commercial/getSetting',
    method: 'post',
    params: query
  })
}





// WEBPACK FOOTER //
// ./src/api/baseinfo.js